import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { ManageObjectivesCommand } from "@shared-kernel/application/ports/student/student-repository";

export const manageObjectives = createApiThunk<void, ManageObjectivesCommand>(
  "student/manageObjectives",
  async (payload, { extra: { studentRepository } }) => {
    return studentRepository!.manageObjectives(payload);
  },
);

export const resetManageObjectives = createAction("student/resetManageObjectives");
